import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { AbstractDropdown } from '@lt/components';
import Icon from '../../../../components/Icon';
import ShareSocialButtons from './ShareSocialButtons';

const SHARE_ICON_WIDTH = 16;

const StyledHead = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.blue};
`;

// TODO: вынести в компонент дропдаун
const StyledDropdown = styled(AbstractDropdown)`
  position: relative;
  display: inline-block;

  ${AbstractDropdown.StyledContentContainer} {
    position: absolute;
    z-index: 2;
    margin-top: 10px;
    min-width: 190px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 20px 0 rgba(191, 191, 172, 0.5);

    ::before {
      position: absolute;
      top: -10px;
      margin-left: 10px;
      width: 0;
      height: 0;
      content: '';
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #fff;
    }
  }

  ${({ stickTo }) =>
    stickTo === 'center' &&
    css`
      ${AbstractDropdown.StyledContentContainer} {
        left: calc(50% + ${SHARE_ICON_WIDTH}px);
        transform: translateX(-50%);

        ::before {
          left: 50%;
          margin-left: -10px;
        }
      }
    `}
`;

const ShareIcon = styled(Icon)`
  margin-right: 7px;
  width: ${SHARE_ICON_WIDTH}px;
  height: ${SHARE_ICON_WIDTH}px;

  path {
    fill: ${({ theme }) => theme.colors.blue};
    stroke: ${({ theme }) => theme.colors.blue};
    stroke-width: 0;
  }
`;

const headRenderer = () => (
  <StyledHead>
    <ShareIcon type="social-share" />
    Поделиться
  </StyledHead>
);

const ShareSocial = ({ description, ...props }) => (
  <StyledDropdown
    {...props}
    headRenderer={headRenderer}
    contentRenderer={() => (
      <ShareSocialButtons networks={['vk']} description={description} />
    )}
  />
);

ShareSocial.propTypes = {
  className: PropTypes.string,
  stickTo: PropTypes.oneOf(['left', 'center']),
  description: PropTypes.string,
};

ShareSocial.defaultProps = {
  className: '',
  stickTo: 'center',
  description: null,
};

export default ShareSocial;
